import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';
import * as React from 'react';
import Button from 'reactstrap/lib/Button';
import { Col, Row } from 'reactstrap';

interface Props {
    onAddImage?: (imageUrl: string) => void;
    onClear?: () => void;
}

interface State {
    imageUrl: string;
}

class AddImage extends React.Component<Props, State> {
    render() {
        return (
                <Row>
                    <Label for={'input-url'} md={2}>Image URL</Label>
                    <Col md={7}>
                        <Input
                            type={'url'}
                            placeholder={'https://yoursite.com/logo.jpg'}
                            className={'w-100'}
                            id={'input-url'}
                            onChange={(e) => {
                                this.setState({imageUrl: e.target.value});
                            }}
                            onKeyDown={ (e) => {
                                if (this.props.onAddImage && e.keyCode === 13) {
                                    this.props.onAddImage(this.state.imageUrl);
                                }
                            }}
                        />
                    </Col>
                    <Col md={2} className={'text-right'}>
                        <Button
                            color={'primary'}
                            className={'js-on-add'}
                            onClick={() => {
                                if (this.props.onAddImage) {
                                    this.props.onAddImage(this.state.imageUrl);
                                }
                            }}
                        >
                            Generate Snippet
                        </Button>
                    </Col>
                    <Col md={1} className={'text-right'}>
                        <Button
                            color={'primary'}
                            className={'js-on-clear'}
                            onClick={() => {
                                if (this.props.onClear) {
                                    this.props.onClear();
                                }
                            }}
                        >
                            Clear
                        </Button>
                    </Col>
                </Row>
        );
    }
}

export default AddImage;